import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Components } from 'safe'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import Datepicker from '../../components/Inputs/Datepicker'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import Select from '../../components/Inputs/Select'
import { TextArea } from '../../components/Inputs/TextArea'
import { dateToDB, formatPipe } from '../../utils/utils'

const AccountingRecordForm: React.FC<IAccountingRecordForm> = ({
  onClose,
  onSubmit,
}) => {
  const form = useForm({
    defaultValues: {
      amount: 0,
    },
  })

  const [selectedAccount, setSelectedAccount] = useState<any | null>(null)

  const type: Components.SelectOption[] = [
    {
      text: 'Haber',
      value: 'CREDIT',
    },
    {
      text: 'Debe',
      value: 'DEBIT',
    },
  ]

  const [typeSelected, setTypeSelected] = useState(null)

  const onSubmitForm = (values) => {
    console.log('selected', selectedAccount)
    console.log('values...', values)
    let body = {
      date: dateToDB(values.date),
      amount: formatPipe(values.amount, true),
      account: {
        id: selectedAccount?.id,
      },
      description: values?.description,
      type: values?.type,
    }
    onSubmit(body)
    // console.log('body...', body)
  }

  return (
    <Form form={form} onSubmit={onSubmitForm} classes={`gap-x-6 gap-y-2`}>
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        Añadir registro contable
      </h2>

      <FormItem
        name="date"
        classes="xl:col-span-6 col-span-12 mt-1"
        rules={{
          required: 'Debe especificar la fecha',
        }}
      >
        <Datepicker label="Fecha" />
      </FormItem>

      <FormItem
        name="name"
        classes="xl:col-span-6 col-span-12"
        rules={{ required: 'Es necesario una cuenta contable' }}
      >
        {/* <InputText label="Emisor" /> */}
        <RawAutoComplete
          label="Cuenta contable"
          url={`accounting/simple-search`}
          bodyGet={'accounts'}
          queryParam={'search'}
          selectedValue={undefined}
          setSelectedValue={(value) => {
            console.log('value..', value)
            setSelectedAccount(value)
          }}
        />
      </FormItem>

      <FormItem
        name="type"
        defaultValue={type[0]}
        classes="xl:col-span-6 col-span-12"
      >
        <Select
          options={type}
          //   setSelectedHelper={(values) => setTypeSelected(values.value)}
          label="Tipo"
        />
      </FormItem>

      <FormItem
        name="amount"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required: 'Debe especificar monto',
        }}
      >
        {/* <InputNumber small label="Monto" addDecimals={true} /> */}
        <CurrencyInput label='Monto' addDecimals={true} mask={'Bs. num'} />
      </FormItem>

      <FormItem
        name="description"
        classes="col-span-12"
        rules={{ required: 'Es necesario el campo' }}
      >
        <TextArea
          label="Descripción"
          placeholder="Ingresar descripción"
          maxLength={255}
        />
      </FormItem>

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Añadir
        </Button>
      </div>
    </Form>
  )
}

interface IAccountingRecordForm {
  onClose: () => void
  onSubmit: (values: any) => void
}

export default AccountingRecordForm
